
export const API_URL_CONSTANT = {
  baseUrl: `${process.env?.REACT_APP_BASE_URL}`, 
}




